function Payroll() {
  return <div className="p-4">Manage Payroll Screen</div>;
}

export default Payroll;
